import React from 'react';

import CookieDetails from '@components/CookieBanner/V1/CookieDetails';
import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';

interface PanelTechnicallyNecessaryProps {
  title: string;
  message: string;
  cookiesInfo: any[];
  cookieInfoLabels: Record<string, any>;
}

const PanelTechnicallyNecessary = ({
  title,
  message,
  cookiesInfo,
  cookieInfoLabels
}: PanelTechnicallyNecessaryProps) => (
  <CookieBannerPanel.Root>
    <CookieBannerPanel.Title>{title}</CookieBannerPanel.Title>
    <CookieBannerPanel.Description parseHTML>{message}</CookieBannerPanel.Description>
    <CookieDetails cookiesInfo={cookiesInfo} cookieInfoLabels={cookieInfoLabels} />
  </CookieBannerPanel.Root>
);

export default PanelTechnicallyNecessary;
